import {
  IssuesFilter as IssuesFilterProto,
  IssueType,
} from "@protos/issues/v1/issues";
import { NOTIFICATIONS_URL } from "@shared/constants";

import { authPost } from "../auth/auth";

export type CreateNangoTicketsRequest = {
  deploymentId: number;
  ticketingId: string;
  multiIssueTickets: boolean;
  issueType: IssueType;
  issueIds?: number[];
  issuesFilter?: IssuesFilterProto;
  projectId?: string;
};

type CreateNangoTicketsBody =
  | { issue_ids: number[]; issue_type: IssueType }
  | { issue_filters: any; issue_type: IssueType };

export type CreateNangoTicketsResponse = {
  failed: {
    error: string;
    issue_ids: number[];
  }[];
  succeeded: {
    ticket_id: number;
    ticket_url: string;
    issue_ids: number[];
    external_slug: string;
  }[];
  skipped: { issue_ids: number[]; reason: string }[];
};

export const createNangoTickets = async (
  options: CreateNangoTicketsRequest
) => {
  const queryParams = new URLSearchParams();
  if (options.projectId) {
    queryParams.set("project_id", options.projectId);
  }
  queryParams.set("group_issues", options.multiIssueTickets.toString());

  let requestBody;
  if (options.issuesFilter) {
    requestBody = {
      issue_type: options.issueType,
      issue_filters: IssuesFilterProto.toJSON(options.issuesFilter),
    };
  } else if (options.issueIds) {
    requestBody = {
      issue_type: options.issueType,
      issue_ids: options.issueIds,
    };
  } else {
    return Promise.reject("No issue ids or filters provided");
  }

  return authPost<CreateNangoTicketsBody, CreateNangoTicketsResponse>(
    `${NOTIFICATIONS_URL}/${options.deploymentId}/ticketing/v2/${
      options.ticketingId
    }/create_tickets?${queryParams.toString()}`,
    requestBody
  );
};
